/* Built In Imports */
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import config from '@config';
import { usePageType } from '@hooks/usePageType';
import { gtmObject } from '@ieo/Components/Form/ieo/api/analyticsAPi';
import { mixPanel } from '@utils/Mixpanel';

/* Services */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';
import { programTypes } from '@ieo/Components/Form/ieo/utils';

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const RegisterStickyButton = ({ sectionContent, region, lang }) => {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(false);
  const { isGiftPage } = usePageType();

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const gtmClick = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'IE_Register_Now',
        IE_LP_Location: 'Sticky_CTA',
      });

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_to_wishlist',
        ecommerce: {
          currency: '', // currency code (Ex - INR,USD,AUD etc.)
          value: '',
          items: [
            {
              item_id: programTypes.IEO, // id of the program
              item_name: 'TYLS Inner Engineering',
              affiliation: '',
              coupon: '',
              discount: 0, //Actual Discount if any (actual price - pay price)
              index: '',
              item_brand: '', // Country Code (Ex - US,IN etc.)
              item_category: '', // Language (Ex - English,Spanish etc.)
              item_category2: '', // Bay Name (not reuired for IE)
              item_category3: '', // New_User or Repeat_User
              item_category4: 'Sticky_CTA',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: '',
              price: '',
              quantity: '',
            },
          ],
        },
      });

      gtmObject({
        event: isGiftPage ? 'IE_Gift_Inner_Engineering' : 'IE_Register_Now',
        IE_LP_Location: 'Sticky_CTA',
        event1: 'view_item',
        item_name: isGiftPage
          ? 'Gift Inner Engineering'
          : 'TYLS Inner Engineering',
        item_category4: 'Sticky_CTA',
      });
    }
    const Mixpanel = mixPanel(router.asPath);
    if (Object.keys(Mixpanel)?.length > 0) {
      Mixpanel.track('ie_registration_cta', {
        cta: 'Sticky Button',
        element: sectionContent[0]?.buttonText,
        language: config.lngList[lang.toLowerCase()],
      });
    }
  };

  const listenToScroll = () => {
    const footerDiv = document.getElementById('footer');
    const bannerDiv = document.getElementById('banner');
    const footerInViewPort = footerDiv && isVisInViewport(footerDiv);
    const bannerInViewPort = bannerDiv && isVisInViewport(bannerDiv);

    if (bannerInViewPort || footerInViewPort) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
    return;
  };

  return (
    isVisible && (
      <Box
        position="fixed"
        top={{ base: 'unset', md: '30%' }}
        bottom={{ base: '2%', md: 'unset' }}
        zIndex="100"
        right={{ base: '50%', md: '0' }}
        maxW={{ base: 'auto', md: '170px', lg: '180px' }}
        transform={{
          base: 'translateX(50%)',
          md: 'none',
        }}
        boxSizing="content-box"
        display="flex"
        justifyContent="flex-end"
      >
        <SimpleButton
          clickHandler={() => {
            gtmClick();
          }}
          style={sectionContent[0]}
          region={region}
          lang={lang}
          whiteSpace="nowrap"
          mb="0"
        />
      </Box>
    )
  );
};

export default RegisterStickyButton;
